import { lazy, Suspense } from 'react';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { useShallow } from 'zustand/react/shallow';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { Cart } from '@/components/cart';
import { SheetCloseSticky } from '../sheet-close-variants/sticky';
import { useGlobalStore } from '@/stores/store';
import { ProceedCheckoutButton } from '@/components/cart/proceed-checkout';
import { TotalMinCost } from './total-min-cost';
import { getGlobalStore } from '@/utils/store';
const ShoppingCartCard = lazy(() => import('./shopping-cart-card/index'));

const ShoppingCartSheet = () => {
  const { setIsShoppingCartOpen } = getGlobalStore();
  const { isShoppingCartOpen, latestMobileOffer, latestBroadbandOffer } =
    useGlobalStore(
      useShallow((state) => ({
        isShoppingCartOpen: state.shoppingCartStore.isShoppingCartOpen,
        latestMobileOffer: state.shoppingCartStore.latestMobileOffer,
        latestBroadbandOffer: state.shoppingCartStore.latestBroadbandOffer,
      }))
    );

  //NOTE: User can't open the shopping cart if it's empty
  const canOpenShoppingCart =
    latestMobileOffer !== null || latestBroadbandOffer !== null;

  const totalItems =
    (latestMobileOffer ? 1 : 0) + (latestBroadbandOffer ? 1 : 0);

  return (
    <Sheet open={isShoppingCartOpen} onOpenChange={setIsShoppingCartOpen}>
      <SheetTrigger
        disabled={!canOpenShoppingCart}
        className="flex cursor-pointer disabled:cursor-default"
      >
        <ShoppingCartIcon className="size-5" />
        <span className="hidden lg:flex bg-warp-green-300 border border-black text-black text-xs font-bold font-nunito700 rounded-full size-5 items-center justify-center">
          {totalItems}
        </span>
        <span className="lg:hidden absolute top-0 right-0 transform translate-x-1/4 -translate-y-1/4 bg-warp-green-300 text-black text-xxs  font-nunito700 border border-black rounded-full size-4 flex items-center justify-center">
          {totalItems}
        </span>
      </SheetTrigger>
      <SheetContent
        className="w-full sm:max-w-none md:max-w-[368px] lg:max-w-[510px] xl:max-w-[510px]"
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        <VisuallyHidden.Root>
          <SheetTitle>Cart</SheetTitle>
          <SheetDescription>Cart items</SheetDescription>
        </VisuallyHidden.Root>
        <SheetCloseSticky
          onClose={() => setIsShoppingCartOpen(false)}
          header="Cart"
        />

        <div className="px-5 pt-4 md:pt-6 md:px-6 lg:px-8 flex flex-col h-full">
          <SheetHeader>
            <Cart />
          </SheetHeader>

          <div className="flex flex-col mt-auto py-12">
            <div className="flex flex-col gap-4 md:gap-6">
              {latestBroadbandOffer !== null && (
                <Suspense fallback={null}>
                  <ShoppingCartCard />
                </Suspense>
              )}
              <TotalMinCost />
            </div>
            <ProceedCheckoutButton />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default ShoppingCartSheet;
